/**
 * getQuizAnswers()
 * Transfers the contents of the answers previously given by the user, to the inputs/textareas of the quiz
 * .quiz-user-answers is populated in /templates/learndash/quiz-answers.php
 */
function getQuizAnswers() {
	const answersWrapper = document.querySelector( '.quiz-user-answers' );

	if ( ! answersWrapper ) {
		return;
	}
	const answers = answersWrapper.querySelectorAll( '.user-given-answer[question-id]' );

	answers.forEach( answer => {
		const answerText = answer.value.trim();
		const answerId = answer.getAttribute( 'question-id' );
		const answerType = answer.tagName.toLowerCase();
		const questionSelector = `.wpProQuiz_questionList[data-question_id="${ answerId }"]`;

		switch ( answerType ) {
			case 'input':
				const optionSet = document.querySelectorAll( `${ questionSelector } .wpProQuiz_questionListItem label` );

				optionSet.forEach( option => {
					const optionText = option.innerText.trim();
					const doesAnswerMatchOption = cleanString( answerText ) === cleanString( optionText );

					// Bail if the answer doesn't match the option.
					if ( ! doesAnswerMatchOption ) {
						return;
					}

					option.classList.add( 'is-selected' );
					option.querySelector( '.wpProQuiz_questionInput' ).checked = true;
				} );

				break;
			case 'textarea':
				const questionField = document.querySelector( `${ questionSelector } .wpProQuiz_questionEssay` );

				questionField.value = answerText;
				questionField.classList.add( 'previously-answered-question' );

				break;
		}
	} );
}
getQuizAnswers();

const bubblesWrapper = document.querySelector( '.wpProQuiz_reviewQuestion' );

/**
 * answersWithSteps()
 *
 * In case of quizzes with steps, instead of just showing all questions at a time,
 * this function will check if the input/textarea content is filled and then
 * find the relative bubble step and add the class necessary
 */
function answersWithSteps() {
	if ( ! bubblesWrapper ) {
		return;
	}
	const questionsWrapper = document.querySelector( '.wpProQuiz_list' );

	const questions = questionsWrapper.querySelectorAll( '.wpProQuiz_listItem' );
	questions.forEach( ( question, qIndex ) => {
		qIndex++;
		const questionType = question.getAttribute( 'data-type' );

		switch ( questionType ) {
			case 'multiple':
				// we're looking for an input and gonna grab the value
				// using querySelectorAll cause this field is a multiple choice one and will contain many input fields
				const questionInputs = question.querySelectorAll( '.wpProQuiz_questionInput' );
				questionInputs.forEach( qInput => {
					const inputStatus = qInput.checked;
					if ( inputStatus === true ) {
						enableBubble( qIndex );
					}
				} );

				break;
			case 'essay':
				// we're looking for a textarea
				const questionText = question.querySelector( '.wpProQuiz_questionEssay' ).value;
				// using trim because sometimes the textarea might hold a space
				if ( questionText.trim() !== '' ) {
					enableBubble( qIndex );
				}
				break;
		}
	} );
}

/**
 * addBubbleObserver
 *
 * Observes the bubble for its classes changing so that it can re-add the required classes as soon
 * as LearnDash's scripts wrongfully removes them.
 *
 * @param {HTMLLIElement} bubble The list element(bubbl) to be observed
 *
 * @return {void}
 */
function addBubbleObserver( bubble ) {
	const observer = new MutationObserver( mutations => {
		mutations.forEach( mutation => {
			if ( mutation.attributeName === 'class' ) {
				const currentClassState = mutation.target.classList.contains( 'wpProQuiz_reviewQuestionSolved' );

				if ( ! currentClassState ) {
					bubble.classList.add( 'wpProQuiz_reviewQuestionSolved' );
				}
			}
		} );
	} );

	observer.observe( bubble, { attributes: true } );
}

answersWithSteps();

/**
 * enableBubble
 *
 * Will be used in case we have bubble steps with numbers for the total number of questions in a quiz
 *
 * @param {number} bubbleIndex
 *
 * @return {void}
 */
function enableBubble( bubbleIndex ) {
	if ( ! bubblesWrapper ) {
		return;
	}

	const bubbles = bubblesWrapper.querySelectorAll( 'li' );

	bubbles.forEach( bubble => {
		const bubbleNumber = parseInt( bubble.innerText );
		if ( bubbleNumber === bubbleIndex ) {
			bubble.classList.add( 'wpProQuiz_reviewQuestionSolved' );
			addBubbleObserver( bubble );
		}
	} );
}

/**
 * cleanString
 *
 * Trims all characters from a string except letters and numbers.
 *
 * @param {string} string
 *
 * @return {string} The passed string, stripped from all characters except numbers and letters.
 */
function cleanString( string ) {
	return string.replace( /[^A-Za-z0-9]/g, '' );
}
